import React from 'react';
import { Container, forwardRef, ContainerProps } from '@chakra-ui/react';
import PhoneCall from './PhoneCtaContainer';

type Props = {
  addphonecalltoaction?: number;
  location?: string;
  variant: 'lightGreySection' | 'darkSection' | 'blueSection';
};

type SectionProps = Props & ContainerProps;

/** A simple Section component for use as a section. Uses rebass box */
const Section = forwardRef<SectionProps, 'div'>((props, ref) => (
  <Container
    as="section"
    {...props}
    pt={props.pt || [8, 24]}
    maxWidth="full"
    ref={ref}
  >
    {props.addphonecalltoaction === 1 && (
      <PhoneCall location={props.location} />
    )}
    {props.children}
  </Container>
));

export default Section;

Section.defaultProps = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
};
